import React, { useState } from 'react';
import './Contact.css';

function Contact() {
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const data = new FormData(form);

    setStatus('sending');

    const response = await fetch('https://formspree.io/f/xwvrwnpg', {
      method: 'POST',
      body: data,
      headers: { Accept: 'application/json' },
    });

    if (response.ok) {
      setStatus('success');
      form.reset();
    } else {
      setStatus('error');
    }
  };

  return (
    <div className="contact">
      <div className="contact__inner">
        <h1>Get in Touch</h1>
        <p>Have a question or want to place a bulk order? We'd love to hear from you.</p>

        <form className="contact__form" onSubmit={handleSubmit}>
          <div className="contact__field">
            <label htmlFor="name">Name</label>
            <input type="text" id="name" name="name" required placeholder="Your name" />
          </div>
          <div className="contact__field">
            <label htmlFor="phone">Phone</label>
            <input type="tel" id="phone" name="phone" required placeholder="Your phone number" />
          </div>
          <div className="contact__field">
            <label htmlFor="message">Message</label>
            <textarea id="message" name="message" required rows="5" placeholder="Your message..." />
          </div>

          <button
            type="submit"
            className="contact__submit"
            disabled={status === 'sending'}
          >
            {status === 'sending' ? 'Sending...' : 'Send Message'}
          </button>

          {status === 'success' && (
            <p className="contact__feedback contact__feedback--success">
              Message sent! We'll get back to you soon.
            </p>
          )}
          {status === 'error' && (
            <p className="contact__feedback contact__feedback--error">
              Something went wrong. Please try again.
            </p>
          )}
        </form>
      </div>
    </div>
  );
}

export default Contact;